export default __webpack_public_path__ + "static/media/vedran-vukman.be39f8b0.jpeg";